import { API_ROOT, MEMBER_BASEURL } from "../config/ApiConfig";

const getPublicStripeKey = (options) => {
  return fetch(API_ROOT + "/stripePublicKey", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        return null;
      }
    })
    .then((data) => {
      if (!data || data.error) {
        console.log("API error:", { data });
        throw Error("API Error");
      } else {
        return data.publicKey;
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

const caremanagerSignup = (firstName, lastName, email, inviteCode) => {
  const body = {
    firstName: firstName === "" ? undefined : firstName,
    lastName: lastName === "" ? undefined : lastName,
    email: email === "" ? undefined : email,
    inviteCode: inviteCode,
  };
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    credentials: "include",
  };
  //return simulateAsyncCall({ status: 200, message: 'Success' });

  return fetch(MEMBER_BASEURL + "/v1/rest/enroll/enterprisePartner", requestOptions)
    .then((r) => r.json().then((data) => ({ status: r.status, body: data })))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.log(err);
      return { status: 500 };
    });
};

const caremanagerEnroll = (fields) => {
  const body = {
    enrollmentType: "caremanager",
    caremanagerId: fields.caremanagerId,
    firstName: fields.firstName,
    lastName: fields.lastName,
    birthDay: fields.birthDay,
    birthMonth: fields.birthMonth,
    birthYear: fields.birthYear,
    phone: fields.phone,
    zipcode: fields.zipcode,
    insuranceMemberId: fields.insuranceMemberId === "" ? undefined : fields.insuranceMemberId,
    insurancePlanName: fields.insurancePlanName === "" ? undefined : fields.insurancePlanName,
    caregiverFirstName: fields.caregiverFirstName === "" ? undefined : fields.caregiverFirstName,
    caregiverLastName: fields.caregiverLastName === "" ? undefined : fields.caregiverLastName,
    caregiverPhone: fields.caregiverPhone === "" ? undefined : fields.caregiverPhone,
    caregiverEmail: fields.caregiverEmail === "" ? undefined : fields.caregiverEmail,
    relationship: fields.relationship === "" ? undefined : fields.relationship,
    reason: fields.reason === "" ? undefined : fields.reason,
  };
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    credentials: "include",
  };
  //return simulateAsyncCall({ status: 200, message: 'Success' });

  return fetch(MEMBER_BASEURL + "/v1/rest/enroll", requestOptions)
    .then((r) => r.json().then((data) => ({ status: r.status, body: data })))
    .then((data) => {
      return data;
    })
    .catch((err) => {
      console.log(err);
      return { status: 500 };
    });
};

/*
function simulateAsyncCall(response) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
        resolve(response);
    }, 300);
  });
}
*/

const api = {
  getPublicStripeKey: getPublicStripeKey,
  caremanagerSignup: caremanagerSignup,
  caremanagerEnroll: caremanagerEnroll,
};

export default api;
